import BoldIcon from "@redotech/redo-icons/bold-01.svg";
import ItalicIcon from "@redotech/redo-icons/italic-01_filled.svg";
import LinkIcon from "@redotech/redo-icons/link-03_filled.svg";
import BulletedListIcon from "@redotech/redo-icons/list_filled.svg";
import OrderedListIcon from "@redotech/redo-icons/numbered-list_filled.svg";
import UnderlineIcon from "@redotech/redo-icons/underline-01_filled.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";

/**
 * Cosmetic toolbar for message input.
 * Buttons are non-functional - will be wired to rich text editor later.
 */
export const MessageInputToolbar = memo(function MessageInputToolbar() {
  return (
    <Flex align="center" gap="xs">
      <Tooltip arrow title="Bold">
        <div>
          <RedoButton hierarchy="tertiary" IconLeading={BoldIcon} size="xs" />
        </div>
      </Tooltip>
      <Tooltip arrow title="Italic">
        <div>
          <RedoButton hierarchy="tertiary" IconLeading={ItalicIcon} size="xs" />
        </div>
      </Tooltip>
      <Tooltip arrow title="Underline">
        <div>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={UnderlineIcon}
            size="xs"
          />
        </div>
      </Tooltip>
      <Tooltip arrow title="Link">
        <div>
          <RedoButton hierarchy="tertiary" IconLeading={LinkIcon} size="xs" />
        </div>
      </Tooltip>
      <Tooltip arrow title="Numbered list">
        <div>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={OrderedListIcon}
            size="xs"
          />
        </div>
      </Tooltip>
      <Tooltip arrow title="Bulleted list">
        <div>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={BulletedListIcon}
            size="xs"
          />
        </div>
      </Tooltip>
    </Flex>
  );
});
